export default __webpack_public_path__ + "static/ti_motorhome_white-33363b7606369a09f212acada3522607.svg";